import Client from './client';

export type ShippoMockTrackStatus =
  | 'PRE_TRANSIT'
  | 'TRANSIT'
  | 'DELIVERED'
  | 'RETURNED'
  | 'FAILURE'
  | 'UNKNOWN';

class ShippoApi {
  public static classInstance?: ShippoApi;

  public static get instance() {
    if (!this.classInstance) {
      this.classInstance = new ShippoApi();
    }
    return this.classInstance;
  }

  /** Link Shippo labels purchased outside the app to orders (admin). */
  public syncOrders(): Promise<{
    scannedTransactions: number;
    linked: Array<{
      orderId: string;
      orderNumber: string | null;
      trackingNumber: string;
      labelFee: number | null;
    }>;
    unmatchedTransactions: number;
  }> {
    return Client.post(`/shippo/sync-orders`, {});
  }

  /** Link one order to its Shippo transaction by tracking number (admin). */
  public syncOrder(orderId: string): Promise<{
    scannedTransactions: number;
    linked: Array<{
      orderId: string;
      orderNumber: string | null;
      trackingNumber: string;
      labelFee: number | null;
    }>;
    unmatchedTransactions: number;
  }> {
    return Client.post(`/shippo/sync-orders/${orderId}`, {});
  }

  /** TEMPORARY — Shippo mock track test helper */
  public triggerMockTrack(
    orderId: string,
    mockStatus: ShippoMockTrackStatus,
  ): Promise<{
    orderId: string;
    orderNumber: string | null;
    mockTrackingNumber: string;
    shippoStatus: string | null;
    shipmentStatus: string;
    shippoTrack: Record<string, unknown>;
  }> {
    return Client.post(`/shippo/test-mock-track`, { orderId, mockStatus });
  }
}

export default ShippoApi.instance;
